 const REMOTEHOST = process.env.REACT_APP_remoteHost;

 export default REMOTEHOST;